<kt-portlet>


	<kt-portlet-header [sticky]="true" [title]="portletTitle" [class]="'kt-portlet__head--lg'">
		<ng-container ktPortletTools>
			<button mat-raised-button color="primary" (click)="create()">{{ 'AddNew' | localize }}</button>
		</ng-container>
	</kt-portlet-header>


	<kt-portlet-body>


	


		<!-- start::DATA GRID -->
		<div class="mat-table__wrapper">


			<mat-table class="lmat-elevation-z8" #table [dataSource]="dataSource" matSort #sort1="matSort"
				matSortActive="id" matSortDirection="asc" matSortDisableClear >

				

				<ng-container matColumnDef="id">
					<mat-header-cell *matHeaderCellDef mat-sort-header width="5%"># Id</mat-header-cell>
					<mat-cell *matCellDef="let dataItem">
						
						<span class="mobile-label">ProductId</span>
						{{dataItem.id}}
					</mat-cell>
				</ng-container>


				<ng-container matColumnDef="productCode">
					<mat-header-cell *matHeaderCellDef mat-sort-header  width="5%"># POSM Kodu</mat-header-cell>
					<mat-cell *matCellDef="let dataItem">
						
						<span class="mobile-label">ProductCode</span>
						{{dataItem.productCode}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="productName">
					<mat-header-cell *matHeaderCellDef mat-sort-header ># POSM</mat-header-cell>
					<mat-cell *matCellDef="let dataItem">
						
						<span class="mobile-label"  >POSM</span>
						<div class="row">	
						<div class="col-lg-2"><kt-product-photo [ProductCode]="dataItem.productCode" [ProductName]="dataItem.productName" [Width]="40" ></kt-product-photo></div>
						
						<div class="col-lg-10">{{dataItem.productName}}</div>
					</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="supplierName">
					<mat-header-cell *matHeaderCellDef mat-sort-header># Tedarikci</mat-header-cell>
					<mat-cell *matCellDef="let dataItem" [matTooltip]="dataItem.supplierAddress" matTooltipShowDelay="200">
						
						<span class="mobile-label" >Tedarikci</span>
						{{dataItem.supplierName}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="amount">
					<mat-header-cell *matHeaderCellDef mat-sort-header># Üretim Miktarı</mat-header-cell>
					<mat-cell *matCellDef="let dataItem">
						
						<span class="mobile-label">Üretim Miktarı</span>
						
						<span class="amount">
						{{dataItem.amount}}
						</span>

						

					</mat-cell>
				</ng-container>


				

				<ng-container matColumnDef="actions">
					<mat-header-cell *matHeaderCellDef>{{ 'TABLE.COLUMN.ACTIONS' | localize }}</mat-header-cell>
					<mat-cell *matCellDef="let dataItem">
						<button  mat-icon-button color="warn" matTooltip="Delete Record" type="button"
							(click)="delete(dataItem)">
							<mat-icon>delete</mat-icon> Sil
						</button>
					</mat-cell>
				</ng-container>

				
				<!-- Sutun tanimlari -->
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

				<!-- Satir ekleme dongusu -->
				<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

			</mat-table>

			<!-- NO RECORD -->

			<div class="mat-table__message" *ngIf="!(dataSource.hasItems$ | async) && !(dataSource.loading$ | async)">
				{{ 'MSG.NORECORD' | localize }}</div>


		</div>
		<!-- end::DATA GRID -->

		<!-- start: BOTTOM -->
		<div class="mat-table__bottom">
			<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
			<mat-paginator [pageSize]="5" [pageSizeOptions]="[3, 5, 10]" [length]="dataSource.totalCount$ | async"
				[showFirstLastButtons]="true"></mat-paginator>
		</div>
		<!-- end: BOTTOM -->

	</kt-portlet-body>

</kt-portlet>
